/// FOURJS_START_COPYRIGHT(D,2024)
/// Property of Four Js*
/// (c) Copyright Four Js 2024, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT
"use strict";

let branchName = "- release";
if (__BRANCH__) {
  branchName = `⎇ ${__BRANCH__}`;
}
console.log(`✨ ⚡ GBC ${__VERSION__} - ${__BUILD__} ⚡ ${branchName}`);
// Instead of blank page, use this splash to match any app loaded afterward
import logoUrl from "../resources/img/logo.png";
document.querySelector("#mainContainer").innerHTML = `
    <header class="mt-toolbar" style="position: fixed; width: 100%;"></header>
    <div style="background: #f7f7f7;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0.2;
    width: 100%;
    height: 100%;">
    <img alt="Genero logo" src="${logoUrl}" style="margin: 10% auto 0; display: block;">
    <div style="padding-top:2em; width: auto; text-align: center;">GBC ${__VERSION__}</div>
    </div>
  `;

import "./libextensions/libextensions"; // Importing the window methods

import "./sysinit/bootstrap/multiWindow";

import "./sysinit/gbc.bootstrap";

import "./sysinit/bootstrap/initWrapper";

// LEGACY: will be removed in the future
import "./libextensions/jsface";
import "./libextensions/modulum";
// END LEGACY

// GBC IS HERE!
import "./sysinit/gbc.js"; // note the .js extension here

if (gbc.version.indexOf("_VERSION_") >= 0) {
  gbc.version = `${__VERSION__}`;
}
if (gbc.build.indexOf("_BUILD_") >= 0) {
  gbc.build = __BUILD__;
}
if (gbc.buildTool.indexOf("_BUILDTOOL_") >= 0) {
  gbc.buildTool = __BUILDTOOL__;
}
if (gbc.tag.indexOf("_TAG_") >= 0) {
  gbc.tag = __TAG__;
}
if (gbc.dirtyFlag.indexOf("_DIRTY_") >= 0) {
  gbc.dirtyFlag = __DIRTY__;
}
if (gbc.lastCompDate.indexOf("_COMPDATE_") >= 0) {
  gbc.lastCompDate = __COMPDATE__;
}
if (gbc.prodMode.indexOf("_PROD_") >= 0) {
  gbc.prodMode = __PROD__;
}
if (gbc.copyrightYear.indexOf("_YEAR_") >= 0) {
  gbc.copyrightYear = __YEAR__;
}

// Sources as barel-files
import "./sysinit/constants/Constants.mjs";
import "./base/aui/Aui.mjs"; // Nodes definitions
import "./base/behaviors/Behaviors.mjs";
import "./base/controller/Controllers.mjs";
import "./base/events/Event";
import "./base/events/EventListener";
import "./base/events/EventListenerNativeClass"; // Used to forget about jsface def in EventListener
import "./base/helpers/Helpers.mjs";
import "./base/layout/Layout.mjs";
import "./base/services/Services.mjs";
import "./base/vm/Vm.mjs";
import "./base/widget/Widgets.mjs";

// This is automatically replaced with correct custo js files see: customizationImporter.js
import "./customization.mjs";

// Everything is ready, time to start GBC!
const startGbc = function (context) {
  context.gbcWrapper.__prepare();
  context.gbcWrapper.on(context.gbcWrapper.events.READY, function () {
    context.gbc.run(function () {
      context.gbcWrapper.__gbcReady();
    });
  });
};

startGbc(window);
